import { common } from "../locales";
import { DEFAULT_LANG } from "../constants";

export function isMobile() {
  return window.innerWidth < 1200;
}

export function debaunce(callback, timeout = 1000) {
  let interval;
  return () => {
    clearInterval(interval);
    interval = setInterval(callback, timeout);
  };
}

export function getAppLangLocal() {
  return localStorage.getItem("app_lang") || DEFAULT_LANG;
}

export function setAppLangLocal(val) {
  localStorage.setItem("app_lang", val);
}

export const t = new Proxy(
  (key) => {
    const lang = getAppLangLocal();
    return common[lang]?.[key] ?? `${key}: not found`;
  },
  {
    get(target, prop) {
      if (typeof prop !== "string") return target[prop];
      return target(prop);
    },
  }
);
